import React from "react";
import { Star } from "lucide-react";

export const TestimonialsSection = () => {
  const pub = process.env.PUBLIC_URL || "";
  const testimonials = [
    { quote: "\"I made a video for my sister's wedding in 10 minutes. My family couldn't believe I made it myself.\"", author: "Rohit Verma", location: "Kanpur", avatarLetter: "R", avatarBg: "bg-[#FF8A65] text-[#1a0a05]" },
    { quote: "\"No typing, no confusion. I just tapped what I wanted and my video was ready.\"", author: "Pooja Sahu", location: "Indore", avatarLetter: "P", avatarBg: "bg-[#4DD0E1] text-[#051a1d]" },
    { quote: "\"I was scared to try an AI app before. Twinnee felt safe and simple from the first tap.\"", author: "Mahesh Patil", location: "Nagpur", avatarLetter: "M", avatarBg: "bg-[#FFB74D] text-[#1c1202]" },
  ];

  return (
    <section id="testimonials" className="text-white py-24 px-4 sm:px-6 lg:px-8 font-sora relative overflow-hidden">
      <div className="absolute top-1/4 -left-28 w-[500px] h-[500px] rounded-full pointer-events-none z-0" style={{ background: "radial-gradient(circle at center, rgba(98,250,227,0.10) 0%, transparent 65%)", filter: "blur(50px)" }} />
      <div className="absolute top-1/3 -right-28 w-[500px] h-[500px] rounded-full pointer-events-none z-0" style={{ background: "radial-gradient(circle at center, rgba(208,188,255,0.12) 0%, transparent 65%)", filter: "blur(50px)" }} />

      <div className="max-w-6xl mx-auto relative z-10">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="text-xs font-semibold tracking-widest text-[#62FAE3] uppercase mb-4 font-mono">WHAT PEOPLE ARE SAYING</p>
          <h2 className="text-4xl sm:text-5xl lg:text-[56px] font-bold tracking-tight leading-[1.15] text-white">
            Loved by{" "}<span className="bg-gradient-to-r from-[#D0BCFF] to-[#62FAE3] bg-clip-text text-transparent">Users</span>
            <br />
            <span className="bg-gradient-to-r from-[#D0BCFF] to-[#62FAE3] bg-clip-text text-transparent">Across India</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-7 max-w-5xl mx-auto mb-16">
          {testimonials.map((t, idx) => (
            <div key={idx} className="relative rounded-[20px] border border-white/[0.08] bg-[#13151c]/90 backdrop-blur-xl p-7 sm:p-8 flex flex-col justify-between transition-all duration-300 hover:border-white/20 h-[280px] shadow-2xl">
              <div>
                <div className="flex items-center gap-1.5 mb-5">
                  {[...Array(5)].map((_, sIdx) => <Star key={sIdx} className="w-3.5 h-3.5 fill-[#F6DFCC] text-[#F6DFCC]" />)}
                </div>
                <p className="text-gray-300 text-xs sm:text-[13px] font-light leading-relaxed italic">{t.quote}</p>
              </div>
              <div className="flex items-center gap-3 pt-4">
                <div className={`w-9 h-9 rounded-xl flex items-center justify-center font-bold text-sm shadow-md shrink-0 ${t.avatarBg}`}>{t.avatarLetter}</div>
                <div>
                  <h4 className="text-sm font-semibold text-white tracking-tight">{t.author}</h4>
                  <p className="text-xs text-gray-400 font-light">{t.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center flex flex-col items-center justify-center pt-2">
          <div className="flex items-center -space-x-2 mb-3">
            <img src={`${pub}/LandingPageAssets/1.png`} alt="Creator" className="w-8 h-8 rounded-full object-cover border-2 border-[#0e1219]" />
            <img src={`${pub}/LandingPageAssets/2.png`} alt="Creator" className="w-8 h-8 rounded-full object-cover border-2 border-[#0e1219]" />
            <img src={`${pub}/LandingPageAssets/3.png`} alt="Creator" className="w-8 h-8 rounded-full object-cover border-2 border-[#0e1219]" />
            <div className="w-8 h-8 rounded-full bg-[#1b2230] border-2 border-[#0e1219] flex items-center justify-center text-[10px] font-bold text-gray-300">+5k</div>
          </div>
          <p className="text-xs sm:text-sm text-gray-400 font-light">Join thousands of creators building the future of cinematic storytelling.</p>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
